export const APP_VERSION = "2026.10.12";
export default APP_VERSION;
